export default {
    ACCEPTED_TRADE: 'Has aceptado el intercambio.',
    ACCEPTED_TRADE_OTHER: 'El otro jugador ha aceptado el intercambio.',
    ALREADY_HAVE_PET: 'Ya tienes una mascota.',
    BLACK_POTION: 'Bebes la poción negra y empiezas a sentirte mal.',
    CANNOT_ADD_ITEMS_TRADE: 'No puede agregar más artículos al intercambio.',
    CANNOT_ATTACK_CHEATER: 'Ese jugador es un tramposo, no quieres atacar a alguien así.',
    CANNOT_ATTACK_CHEATER_SELF:
        'Lo siento, pero los tramposos no pueden atacar a otros jugadores, ¡eso no sería justo para ellos!',
    CANNOT_ATTACK_MOB: 'No tienes motivos para atacar a estas criaturas.',
    CANNOT_ATTACK_PET: '¿Estás loco? ¿Por qué atacarías a una mascota?',
    CANNOT_ATTACK_PREY: 'No puedes atacar mientras eres la presa.',
    CANNOT_ATTACK_TARGET: 'No puedes atacar a alguien que no es tu objetivo.',
    CANNOT_ATTACK_LEVEL_DIFF:
        'No puedes atacar a alguien con 30 niveles por encima o por debajo de ti.',
    CANNOT_DO_THAT: 'No puedes hacer eso ahora mismo.',
    CANNOT_DROP_ITEM_DOOR:
        'No puedes dejar caer este artículo mientras estás parado en una puerta.',
    CANNOT_PASS_DOOR: 'No puedes pasar por esta puerta.',
    CANNOT_GLOBAL_CHAT_SECONDS:
        'Debes esperar otros {{duration}} segundos antes de usar el chat global.',
    CANNOT_GLOBAL_CHAT_MINUTES:
        'Debes esperar otros {{duration}} minutos antes de usar el chat global.',
    CANNOT_GLOBAL_CHAT_JAIL: 'No puedes usar el chat global mientras estás encarcelado.',
    CANNOT_PICK_UP_ITEM: 'Este artículo solo puede ser recogido por {{username}}.',
    CANNOT_TALK: 'No puedes hablar ahora.',
    CANNOT_TRADE_ITEM: 'No puedes intercambiar este artículo.',
    CANNOT_TRADE_CHEATER: 'Lo sentimos, pero los tramposos no pueden comerciar.',
    CANNOT_TRADE_CHEATER_OTHER: '¡Ese jugador es un tramposo, podría venderte contrabando!',
    CANNOT_TRADE_ADMIN: 'Como administrador, no puedes influenciar la economía.',
    CANNOT_TRADE_ADMIN_OTHER: 'El jugador es un administrador y no se puede comerciar con él.',
    DONT_THINK_GO_IN: 'No creo que deba entrar allí todavía...',
    ENTERED_LOBBY: 'Has entrado en el lobby de {{name}}.',
    EXITED_LOBBY: 'Has dejado el lobby de {{name}}.',
    IN_PVP_ZONE: '¡Has entrado en una zona PvP!',
    INVALID_AMOUNT: 'Has introducido una cantidad no válida.',
    DOOR_KEY_CRUMBLES: 'La llave se convierte en polvo al pasar por la puerta.',
    MINIMUM_PLAYERS_MINIGAME:
        'Debe haber al menos {{minimum}} jugadores para comenzar este minijuego.',
    NEED_COMBAT: 'Debes estar en combate para usar esta habilidad.',
    NEED_WAIT_ABILIY: 'Debes esperar {{duration}} segundos antes de volver a usar esta habilidad.',
    NO_IDEA: 'No tengo idea de qué es eso.',
    NO_ARROWS: 'No tienes flechas para disparar.',
    NO_ACHIEVEMENT_DOOR: 'Debes completar el logro {{achievement}} para pasar por esta puerta.',
    NO_COMBAT_DOOR: 'Tu nivel de combate debe ser al menos {{level}} para participar.',
    NO_QUEST_DOOR: 'Debes completar la misión {{quest}} para atravesar esta puerta.',
    NO_KEY_DOOR: 'No tienes la llave requerida para pasar por esta puerta.',
    NO_SKILL_DOOR: 'Tu {{skill}} debe tener al menos {{level}} para participar.',
    NO_KNOWLEDGE_USE: 'No tienes el conocimiento para usar esto.',
    NO_SPACE: 'No tienes suficiente espacio en tu inventario.',
    NO_SPACE_OTHER: 'El otro jugador no tiene suficiente espacio en su inventario.',
    NO_SPACE_PET: 'No tienes suficiente espacio en tu inventario de mascotas.',
    NOT_IN_PVP_ZONE: '¡Ya no estás en una zona PvP!',
    NOT_ONLINE: 'El jugador @aquamarine@{{username}}@crimson@ no está en línea.',
    NOT_ENOUGH_MANA: 'No tienes suficiente mana para usar esta habilidad.',
    PLEASE_MAKE_ROOM_REWARD: 'Haz espacio en tu inventario para aceptar esta recompensa.',
    POISONED: '¡Has sido envenenado!',
    POISON_WORN_OFF: 'El veneno ha desaparecido.',
    PLEASE_REPORT_BUG: 'Se ha producido un error, repórtalo como un bug.',
    FREEZE_IMMUNITY:
        'Ahora eres inmune a los efectos de congelación durante {{duration}} segundos.',
    FREEZE_IMMUNITY_WORN_OFF: 'Tu inmunidad a los efectos de congelación ha desaparecido.',
    FIRE_IMMUNITY: 'Ahora eres inmune a los efectos de fuego durante {{duration}} segundos.',
    FIRE_IMMUNITY_WORN_OFF: 'Tu inmunidad a los efectos del fuego ha desaparecido.',
    FRIENDS_USERNAME_TOO_LONG: 'Ese nombre de usuario es demasiado largo.',
    FRIENDS_ADD_SELF:
        'Escucha, lo entiendo, te sientes solo. Pero no puedes agregarte a ti mismo a la lista de amigos.',
    FRIENDS_ALREADY_ADDED: 'Ese jugador ya está en tu lista de amigos.',
    FRIENDS_USER_DOES_NOT_EXIST: 'No existe ningún jugador con ese nombre de usuario.',
    FRIENDS_NOT_IN_LIST: 'Ese jugador no está en tu lista de amigos.',
    PEOPLE_ONLINE: 'Actualmente hay {{population}} personas en línea.',
    SKILL_LEVEL_UP: '¡Sube el nivel de habilidad!',
    SKILL_LEVEL_UP_DESC: '¡Felicitaciones, tu {{skill}} ha alcanzado el nivel {{level}}!!',
    JAILED: 'Actualmente estás encarcelado por {{duration}}.',
    MUTED: 'Actualmente estás silenciado.',
    LOW_MANA: 'Tienes poco mana, tus ataques serán más débiles.',
    TRADE_REQUEST: 'Has solicitado comerciar con {{username}}.',
    TRADE_REQUEST_OTHER: '{{username}} ha solicitado comerciar contigo.',
    TRADE_EMPTY: '¿Oye, por qué no intercambias nada?',
    TRADE_COMPLETE: '¡Gracias por usar el sistema de comercio de Kaetram!',
    WELCOME: '¡Bienvenido a {{name}}!',
    WELCOME_BACK: '¡Bienvenido de nuevo a {{name}}!',
    WHY_GO_THERE: 'Espera, ¿por qué querría entrar allí?'
} as const;
